import { Box, Divider, Typography } from '@mui/material';
import { jbColors } from 'theme/jbColors';
import { theme } from 'theme';

export const dividerStyles = {
  divider: {
    flex: 1,
    height: '1px',
    marginLeft: theme.spacing(1),
    bottom: '3px',
    position: 'relative',
    marginBottom: '24px',
    borderColor: jbColors.core.reflexBlue[40],
  },
};

const DividerTitle = ({ text }: { text: string }) => {
  return (
    <Box data-testid={'divider-title'} display="flex" alignItems="baseline">
      <Typography color="primary" variant={'h6'}>
        {text}
      </Typography>
      <Divider sx={dividerStyles.divider} />
    </Box>
  );
};

export { DividerTitle };
